import PostDiscussionPage from "../../postAdmin/PostDiscussionPage";

const PostDiscussionDetail = ({ backPath = "/partner/posts" }) => {
  return <PostDiscussionPage back={backPath} />;
};

export default PostDiscussionDetail;
